import { ANALYTICS_TRIGGERS } from '@24i/nxg-sdk-smartott-shared/src/analytics/constants';
import { AdEvent } from '@24i/nxg-sdk-photon/src/analytics/player';

import { Payload, AdSkippedResult } from '../types';
import { mapBase } from './mapBase';

export const mapAdSkipped = (
    triggerName: ANALYTICS_TRIGGERS,
    payload: Payload
): AdSkippedResult => {
    const adPayload = payload?.payload as unknown as AdEvent;
    return {
        ...mapBase(payload),
        action: triggerName,
        event_trigger: triggerName,
        thing_id: payload?.payload?.asset?.id || '',
        player_advertisment_name: adPayload?.adName,
        player_advertisment_position: adPayload?.adPosition,
    };
};
